<script>
import { mapActions } from "vuex";

import BaseListView from "../base/BaseListView.vue";

import BaseSupplierDialogSelector from "@/components/shared/BaseDialogSelectors/BaseSupplierDialogSelector.vue";

export default {
  extends: BaseListView,
  components: {
    BaseSupplierDialogSelector
  },
  page: {
    title: "Purchases",
  },
  data() {
    return {
      fields: [
        { key: "document_number", sortable: true, sortKey: "purchase_number"},
        { key: "date", sortable: true },
        { key: "location.name", label: "Location" },
        "status",
        { key: "supplier.name", label: "Supplier" },
        "subject",
        "total",
        "edit",
        { key: "archive", label: "Void" },
      ],
      purchases: {},
      query_params: {
        page: 1,
        page_size: 25,
        ordering: '-date, -purchase_number',
        search: null,
      },
    };
  },
  methods: {
    ...mapActions("purchases", ["fetchPurchases"]),
    ...mapActions("application", ["setIsTableLoading"]),

    create() {
      this.$router.push({
        name: "Edit Purchase",
      });
    },

    edit(id) {
      this.$router.push({
        name: "Edit Purchase",
        params: {
          id: id,
        },
      });
    },

    query() {
      this.setIsTableLoading(true);
      this.fetchPurchases({
        organisation: this.getCurrentOrganisation.id,
        ...this.query_params,
      }).then((res) => {
        this.purchases = res.data;
      }).catch((error) => {
      }).finally(() => {
        this.setIsTableLoading(false);
      });
    },
  },
  mounted() {
    // this.query_params.ordering = '-date, -purchase_number'
    // this.query();
  },
};
</script>

<template>
  <div>
    <PageHeader
      :modelName="Purchases"
      @create="create"
      @showfilters="show_filters = $event"
      v-model="query_params.search"
    />

    <div class="mx-1 mb-2" ref="filters" :hidden="!show_filters">
      <div class="row mb-3">
        <div class="col-3">
          <base-toggle-button-group id="archived" label="Archived" variant="primary" v-model="query_params.archived" :options="archived_options"/>
        </div>
        <div class="col-3">
          <base-input label="Start Date" type="date" v-model="query_params.date_start" />
        </div>
        <div class="col-3">
          <base-input label="End Date" type="date" v-model="query_params.date_end" />
        </div>
        <div class="col-3">
          <base-input
            label="Delivery Date"
            type="date"
            v-model="query_params.delivery_date"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-3">
          <base-location-selector v-model="query_params.location" />
        </div>
        <div class="col-3">
          <base-purchase-selector label_name="Parent" v-model="query_params.parent" />
        </div>
        <div class="col-3">
          <base-input type="multiselect" id="payment_status" label="Payment Status" v-model="query_params.payment_status" :options="['Paid', 'Unpaid']" />
        </div>
        <div class="col-3">
          <base-input type="multiselect" id="status_filter" v-model="query_params.status" :options="['Draft', 'Confirmed']" />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-3">
          <BaseSupplierDialogSelector v-model="query_params.supplier" disableAdd disableModals />
        </div>
        <div class="col-3">
          <base-user-selector label_name="Purchase Person" v-model="query_params.purchase_person" />
        </div>
      </div>
      <el-divider class="my-4"></el-divider>
    </div>

    <base-card>
      <base-table
        ref="table"
        :data_="purchases"
        :fields="fields"
        @archive="archive"
        @edit="edit"
        @page_change="query_params.page = $event"
        @page_size_change="query_params.page_size = $event"
        @ordering_change="query_params.ordering = $event"
      />
    </base-card>
  </div>
</template>